import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { ActivityAsyncAdapter } from './activity.adapter';
import { KustoActivity } from 'app/model/pipeline/kusto.activity';

import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { ReferenceAdapter } from '../reference.adapter';
import { LinkedService } from 'app/model/linkedservice/linkedservice';
import { ValueAdapter } from './../value.adapter';
import _ from 'lodash';
import { KustoLinkedService } from 'app/model/linkedservice/kusto.linkedservice';
import { linkedServiceReferenceWithoutParameterizationRemainer } from '../reference-remainer';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(KustoActivity),
    asynchronous: true,
    adapts: {
        name: '*',
        description: '*',
        type: '*',
        linkedServiceName: linkedServiceReferenceWithoutParameterizationRemainer,
        policy: '*',
        dependsOn: '*',
        userProperties: '*',
        typeProperties: {
            database: '*',
            command: '*',
            commandType: '*'
        }
    }
})
export class KustoActivityAdapter extends ActivityAsyncAdapter<KustoActivity, Model.KustoActivity> {

    public model(): IModel {
        return Metamodel.modelFor(KustoActivity);
    }

    protected async _toResource(activity: KustoActivity): Promise<Model.KustoActivity> {
        const modelKustoActivity: Model.KustoActivity = super._getCommonActivityProperties(activity, 'KustoCommand') as Model.KustoActivity;
        const kustoActivity: KustoActivity = activity as KustoActivity;

        modelKustoActivity.typeProperties = {
            database: ValueAdapter.toResource(kustoActivity, KustoActivity.DATABASE),
            command: ValueAdapter.toResource(kustoActivity, KustoActivity.COMMAND),
            commandType: ValueAdapter.toResource(kustoActivity, KustoActivity.COMMAND_TYPE)
        };

        if (kustoActivity.linkedService) {
            modelKustoActivity.linkedServiceName = this._toLinkedServiceReferenceModel(kustoActivity.linkedService);
        }

        if (activity.raw) {
            const parsed = JSON.parse(activity.raw);
            // Overlay this on hive activity
            _.merge(modelKustoActivity, parsed);
        }

        return modelKustoActivity;
    }

    protected async _toModel(modelActivity: Model.KustoActivity): Promise<KustoActivity> {
        const activity: KustoActivity = KustoActivity.MODEL.create<KustoActivity>(modelActivity.name);
        const modelKustoActivity = modelActivity as Model.KustoActivity;

        this._updatedCommonProperties(modelActivity, activity);

        if (modelKustoActivity.typeProperties) {
            ValueAdapter.toModel(activity, KustoActivity.DATABASE, modelKustoActivity.typeProperties.database);
            ValueAdapter.toModel(activity, KustoActivity.COMMAND, modelKustoActivity.typeProperties.command);
            ValueAdapter.toModel(activity, KustoActivity.COMMAND_TYPE, modelKustoActivity.typeProperties.commandType);
        }

        if (modelKustoActivity.linkedServiceName !== undefined) {
            activity.linkedService = ReferenceAdapter.toProxyModel<LinkedService>(Metamodel.modelFor(KustoLinkedService),
                modelKustoActivity.linkedServiceName, this.context);
        }

        activity.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelKustoActivity, KustoActivity.MODEL));

        return activity;
    }
}
